module.exports = __webpack_public_path__ + "img/lifeiot-min.6713e0e7.png";